import { render, staticRenderFns } from "./AddToCartPopinCds.vue?vue&type=template&id=cd5942b4&scoped=true"
import script from "./AddToCartPopinCds.vue?vue&type=script&lang=js"
export * from "./AddToCartPopinCds.vue?vue&type=script&lang=js"
import style0 from "./AddToCartPopinCds.vue?vue&type=style&index=0&id=cd5942b4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd5942b4",
  null
  
)

export default component.exports